import { render, staticRenderFns } from "./rollingCastle.vue?vue&type=template&id=b5fb5534&"
import script from "./rollingCastle.vue?vue&type=script&lang=js&"
export * from "./rollingCastle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports